import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBankAccount } from "src/models/Prices/Bank.models";

interface BankAccountState {
  bankAccounts: IBankAccount[];
  bankAccountToEdit: IBankAccount | null;
}

const initialState: BankAccountState = {
  bankAccounts: [],
  bankAccountToEdit: null,
};

const BankAccountSlice = createSlice({
  name: "BankAccount",
  initialState,
  reducers: {
    setBankAccountList: (state, action: PayloadAction<IBankAccount[]>) => {
      state.bankAccounts = action.payload;
    },
    setBankAccountToEdit: (state, action: PayloadAction<IBankAccount | null>) => {
      state.bankAccountToEdit = action.payload;
    },
    concatListBankAccount: (state: BankAccountState, action: PayloadAction<IBankAccount[]>) => {
      state.bankAccounts = [...state.bankAccounts.concat(action.payload)];
    },
    addBankAccount: (state, action: PayloadAction<IBankAccount>) => {
      state.bankAccounts.push(action.payload);
    },
    updateBankAccount: (state, action: PayloadAction<IBankAccount>) => {
      let itemIndex = state.bankAccounts.findIndex(
        item => item.bankAccountId === action.payload.bankAccountId
      );
      if (itemIndex !== -1) state.bankAccounts[itemIndex] = action.payload;
    },
    deleteBankAccount: (state, action: PayloadAction<number>) => {
      const newArray = state.bankAccounts.filter(
        item => item.bankAccountId !== action.payload
      );
      state.bankAccounts = newArray;
    },
  },
});

export const {
  setBankAccountList,
  concatListBankAccount,
  setBankAccountToEdit,
  addBankAccount,
  updateBankAccount,
  deleteBankAccount,
} = BankAccountSlice.actions;

export default BankAccountSlice.reducer;
